/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './relation.reducer';

export const RelationDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const relationEntity = useAppSelector(state => state.relation.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="relationDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.relation.detail.title">Relation</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.relation.id">Id</Translate>
            </span>
          </dt>
          <dd>{relationEntity.id}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="tinyMedicRestApp.relation.description">Description</Translate>
            </span>
          </dt>
          <dd>{relationEntity.description}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.relation.active">Active</Translate>
            </span>
          </dt>
          <dd>{relationEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.relation.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{relationEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.relation.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{relationEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.relation.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{relationEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.relation.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{relationEntity.cursor}</dd>
          <dt>
            <span id="relationCode">
              <Translate contentKey="tinyMedicRestApp.relation.relationCode">Relation Code</Translate>
            </span>
          </dt>
          <dd>{relationEntity.relationCode}</dd>
        </dl>
        <Button tag={Link} to="/relation" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/relation/${relationEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default RelationDetail;
